import classNames from "classnames";
import React from "react";

import SquaberLink from "../../../../../common/SquaberLink";

export const SimpleButton = ({
  text,
  onClick,
  icon,
  showBackground,
  highlighted,
  to,
  alt = ""
}) => {
  const className = classNames(
    "text-xs flex gap-1.5 py-1 px-1 align-center rounded font-medium text-black hover:opacity-65",
    {
      "bg-gray-3 border border-gray-3": showBackground,
      "bg-yellow border border-yellow-1": highlighted,
      "bg-none b-none": !showBackground
    }
  );

  const iconNode = icon ? (
    React.isValidElement(icon) ? (
      icon
    ) : (
      <img src={icon} alt={alt} width={16} height={16} />
    )
  ) : null;

  const child = (
    <>
      {iconNode}
      {text ? <span>{text}</span> : null}
    </>
  );

  if (to) {
    return (
      <SquaberLink to={to}>
        <div className={className} onClick={onClick}>
          {child}
        </div>
      </SquaberLink>
    );
  }

  return (
    <button className={className} onClick={onClick}>
      {child}
    </button>
  );
};
